var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:_vm.$options.name},[(_vm.loading)?_c('Loader'):_c('Mapbox',{attrs:{"access-token":"pk.eyJ1IjoicmlkZW5pY2ViaWtlIiwiYSI6ImNqd3V6bGdwcTA0Zjk0YWxmYTNwb2IxeTgifQ.EM4THHDMhVkW0CsUW8zeog","map-options":{
    style: 'mapbox://styles/ridenicebike/cjwv0nfqmh9mh1cp9wlp25131',
    center: [this.longitude, this.latitude],
    zoom: 12
  },"geolocate-control":{
    show: true,
    position: 'top-right'
  },"fullscreen-control":{
    show: true,
    position: 'top-right'
  }},on:{"map-load":_vm.mapLoaded}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }